var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFoodIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.74036 13.213C5.23793 12.9248 4.89844 12.3834 4.89844 11.7637C4.89844 9.20588 6.97932 7.125 9.53711 7.125H11.4487L11.5387 5.64062H0.707397L1.48539 18.477C1.50322 18.7708 1.7466 19 2.04102 19H5.45653C5.10631 18.5345 4.89844 17.9562 4.89844 17.3301C4.89844 16.6083 5.35883 15.9921 6.00128 15.7595C5.77355 15.4102 5.64062 14.9939 5.64062 14.5469C5.64062 14.0994 5.77384 13.6826 6.00201 13.3331C5.82052 13.2923 5.71977 13.2521 5.74036 13.213Z",
    fill: "#111F3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.12247 4.52749C6.1229 4.52749 6.12334 4.52734 6.12377 4.52734H11.6895C11.9969 4.52734 12.2461 4.27816 12.2461 3.9707C12.2461 3.66325 11.9969 3.41406 11.6895 3.41406H7.15066L8.65112 1.11328H10.5762C10.8836 1.11328 11.1328 0.864098 11.1328 0.556641C11.1328 0.249184 10.8836 0 10.5762 0H8.34961C8.16145 0 7.98605 0.0949478 7.88342 0.252518L5.82153 3.41406H0.556641C0.249184 3.41406 0 3.66325 0 3.9707C0 4.27816 0.249184 4.52734 0.556641 4.52734H6.12044C6.12116 4.52734 6.12189 4.52749 6.12247 4.52749Z",
    fill: "#111F3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.01172 11.7637C6.01172 12.0711 6.2609 12.3203 6.56836 12.3203H18.4434C18.7508 12.3203 19 12.0711 19 11.7637C19 9.81978 17.4185 8.23828 15.4746 8.23828H9.53711C7.59322 8.23828 6.01172 9.81978 6.01172 11.7637Z",
    fill: "#111F3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.86719 13.4336C7.25227 13.4336 6.75391 13.932 6.75391 14.5469C6.75391 15.1618 7.25227 15.6602 7.86719 15.6602H17.1445C17.7594 15.6602 18.2578 15.1618 18.2578 14.5469C18.2578 13.932 17.7594 13.4336 17.1445 13.4336H7.86719Z",
    fill: "#111F3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4434 16.7734H6.56836C6.2609 16.7734 6.01172 17.0226 6.01172 17.3301C6.01172 18.2509 6.76086 19 7.68164 19H17.3301C18.2509 19 19 18.2509 19 17.3301C19 17.0226 18.7508 16.7734 18.4434 16.7734Z",
    fill: "#111F3E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_578"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodIcon);
export default __webpack_public_path__ + "static/media/foodIcon.1f4394f09e268206c734be53fa44e3bb.svg";
export { ForwardRef as ReactComponent };